import { useEffect, useRef } from 'react'

export function useIntersectionObserver(options = {}) {
    const elementRef = useRef(null)

    useEffect(() => {
        const element = elementRef.current
        if (!element) return

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    element.classList.add('is-visible')
                    if (options.once) {
                        observer.unobserve(element)
                    }
                } else {
                    if (!options.once) {
                        element.classList.remove('is-visible')
                    }
                }
            })
        }, {
            threshold: options.threshold || 0.1,
            root: options.root,
            rootMargin: options.rootMargin
        })

        observer.observe(element)

        return () => {
            observer.disconnect()
        }
    }, [options.threshold, options.once, options.root, options.rootMargin])

    return elementRef
}

export default useIntersectionObserver
